import * as ents from '@attain-apps/entities'

import * as common from '../../../common'
import type * as models from '../models'

export function transformUsersToAgentAssignments(
  users:
    | {
        items?:
          | readonly ({
              info?: {
                id: string
                firstName?: string | null
                lastName?: string | null
              } | null
              agents?:
                | readonly ({
                    id?: string | null
                    access?: number | null
                  } | null)[]
                | null
            } | null)[]
          | null
      }
    | null
    | undefined,
): readonly models.AgentAssignment[] {
  if (!users?.items) {
    return []
  }

  const result: models.AgentAssignment[] = []

  for (const item of users.items) {
    if (!item?.info || !item.agents) {
      continue
    }

    const user = item.info

    for (const agent of item.agents) {
      if (!agent?.id) {
        continue
      }

      const agentId = common.gql.enums.agentId.TRANSFORMER.getEntityFrom(
        agent.id,
      )
      if (!agentId) {
        continue
      }

      result.push({
        access: agent.access ?? 0,
        agentId,
        agentName: ents.core.agent.Display.get(agentId)?.name ?? agentId,
        id: `${user.id}_${agentId}`,
        userId: user.id,
        userName:
          user.firstName && user.lastName
            ? `${user.firstName} ${user.lastName}`
            : (user.firstName ?? user.lastName ?? 'Unknown User'),
      })
    }
  }

  return result
}
